import Splide from '@splidejs/splide'
import '@splidejs/splide/dist/css/themes/splide-default.min.css'

function initSlider(el) {
  if (!el || el.dataset.splideInit) return

  el.dataset.splideInit = '1'

  new Splide(el, {
    fixedWidth: '75%',
    arrows: false,
    pagination: true,
    flickMaxPages: 1,
    mediaQuery: 'min',
    breakpoints: {
      750: {
        destroy: true
      }
    }
  }).mount()
}

function initCategoryBlocks(root) {
  // Init for whole document on load, or re-rendered section in theme editor
  const scope = root && root.querySelectorAll ? root : document
  scope.querySelectorAll('.category-blocks__slider').forEach(initSlider)
}

initCategoryBlocks(document)

// Reinit when a section is re-rendered in the theme editor
document.addEventListener('shopify:section:load', (event) => {
  initCategoryBlocks(event.target)
})
